/*
 * kp-filter-weergave.js — kadopapier.net, 09-10-2026 (bordtaak #498, B1/B2)
 * Alleen WEERGAVE van de filters op collectiepagina's; data en filter-URL's blijven gelijk.
 *
 * B1  Dubbele getalwaarden ("125" en "125.00" in custom.aantal / custom.variant) worden één regel.
 *     De eerste (kortste) schrijfwijze blijft zichtbaar met het opgetelde aantal; de andere
 *     checkbox(en) blijven in het formulier maar worden verborgen en gaan mee aan/uit.
 *     Kiezen van "125" filtert dus op 125 én 125.00 (Shopify: meerdere waarden = OF).
 *     Het filter-chipje bovenaan verwijdert ook beide waarden.
 * B2  Kleurnamen (custom.kleur_variant, Engelse/CSS-namen) krijgen een naam in de taal van de
 *     pagina (nl/de/en) in tooltip, schermlezertekst en filter-chipje. Onbekende waarde: originele naam.
 *     Op .de ook het zichtbare label en de kleur van het rondje (#656 punt 11, optie B, 26-10-2026).
 */
(function () {
  if (window.kpFilterWeergave) return;
  window.kpFilterWeergave = true;

  var KLEUREN = {
    'white': ['Wit', 'Weiß', 'White'],
    'wit': ['Wit', 'Weiß', 'White'],
    'royalblue': ['Koningsblauw', 'Königsblau', 'Royal blue'],
    'green': ['Groen', 'Grün', 'Green'],
    'groen': ['Groen', 'Grün', 'Green'],
    'red': ['Rood', 'Rot', 'Red'],
    'rood': ['Rood', 'Rot', 'Red'],
    'black': ['Zwart', 'Schwarz', 'Black'],
    'gold': ['Goud', 'Gold', 'Gold'],
    'goud': ['Goud', 'Gold', 'Gold'],
    'pink': ['Roze', 'Rosa', 'Pink'],
    'roze': ['Roze', 'Rosa', 'Pink'],
    'sandybrown': ['Zandbruin', 'Sandbraun', 'Sandy brown'],
    'purple': ['Paars', 'Lila', 'Purple'],
    'silver': ['Zilver', 'Silber', 'Silver'],
    'zilver': ['Zilver', 'Silber', 'Silver'],
    'dessin': ['Dessin', 'Muster', 'Pattern'],
    'orange': ['Oranje', 'Orange', 'Orange'],
    'brown': ['Bruin', 'Braun', 'Brown'],
    'bruin': ['Bruin', 'Braun', 'Brown'],
    'yellow': ['Geel', 'Gelb', 'Yellow'],
    'geel': ['Geel', 'Gelb', 'Yellow'],
    'fuchsia': ['Fuchsia', 'Fuchsia', 'Fuchsia'],
    'grey': ['Grijs', 'Grau', 'Grey'],
    'peru': ['Okerbruin', 'Ockerbraun', 'Ochre brown'],
    'tan': ['Zandkleur', 'Sandfarben', 'Tan'],
    'moccasin': ['Lichtbeige', 'Hellbeige', 'Light beige'],
    'burlywood': ['Houtbruin', 'Holzbraun', 'Wood brown'],
    'blue': ['Blauw', 'Blau', 'Blue'],
    'lightgoldenrodyellow': ['Lichtgeel', 'Hellgelb', 'Light yellow'],
    'multicolour': ['Meerkleurig', 'Mehrfarbig', 'Multicolour'],
    'mistyrose': ['Lichtroze', 'Hellrosa', 'Light pink'],
    'mintcream': ['Mintwit', 'Mintweiß', 'Mint white'],
    'dark green': ['Donkergroen', 'Dunkelgrün', 'Dark green'],
    'darkgreen': ['Donkergroen', 'Dunkelgrün', 'Dark green'],
    'olijfgroen': ['Olijfgroen', 'Olivgrün', 'Olive green'],
    'assorti': ['Assorti', 'Sortiert', 'Assorted'],
    'ivory': ['Ivoor', 'Elfenbein', 'Ivory'],
    'ivoor': ['Ivoor', 'Elfenbein', 'Ivory'],
    'mix': ['Mix', 'Mix', 'Mix'],
    'burgundy': ['Bordeaux', 'Bordeaux', 'Burgundy'],
    'bordeaux': ['Bordeaux', 'Bordeaux', 'Burgundy'],
    'lavender': ['Lavendel', 'Lavendel', 'Lavender'],
    'beige': ['Beige', 'Beige', 'Beige'],
    'natural': ['Naturel', 'Natur', 'Natural'],
    'naturel': ['Naturel', 'Natur', 'Natural'],
    'crème': ['Crème', 'Creme', 'Cream'],
    'creme': ['Crème', 'Creme', 'Cream'],
    'cognac': ['Cognac', 'Cognac', 'Cognac'],
    'metallic': ['Metallic', 'Metallic', 'Metallic'],
    'limegreen': ['Limoengroen', 'Limettengrün', 'Lime green'],
    'slategrey': ['Leisteengrijs', 'Schiefergrau', 'Slate grey'],
    'sand': ['Zand', 'Sand', 'Sand'],
    'khaki': ['Kaki', 'Khaki', 'Khaki'],
    'light grey': ['Lichtgrijs', 'Hellgrau', 'Light grey'],
    'peachpuff': ['Perzik', 'Pfirsich', 'Peach'],
    'goldenrods': ['Goudgeel', 'Goldgelb', 'Golden yellow'],
    'turqouise': ['Turquoise', 'Türkis', 'Turquoise'],
    'taupe': ['Taupe', 'Taupe', 'Taupe'],
    'aqua': ['Aqua', 'Aqua', 'Aqua'],
    'jaguar': ['Jaguarprint', 'Jaguar-Muster', 'Jaguar print'],
    'koeienvlekken': ['Koeienvlekken', 'Kuhflecken', 'Cow print'],
    'choco': ['Chocoladebruin', 'Schokobraun', 'Chocolate'],
    'mediumaquamarine': ['Aquamarijn', 'Aquamarin', 'Aquamarine'],
    'firebrick': ['Steenrood', 'Ziegelrot', 'Brick red']
  };
  // In de/en zijn de metafieldwaarden zelf (automatisch) vertaald; die vormen wijzen naar dezelfde kleur.
  var ALIAS = {
    'blau': 'blue', 'braun': 'brown', 'bräunen': 'tan', 'burgund': 'burgundy', 'design': 'dessin', 'ed': 'red',
    'elfenbein': 'ivory', 'gelb': 'yellow', 'grau': 'grey', 'grün': 'green', 'kräftiges holz': 'burlywood',
    'königsblau': 'royalblue', 'lavendel': 'lavender', 'lila': 'purple', 'limettengrün': 'limegreen',
    'metallisch': 'metallic', 'mokassin': 'moccasin', 'natürlich': 'natural', 'olive': 'olijfgroen', 'rosa': 'pink',
    'rot': 'red', 'sandy brown': 'sandybrown', 'schiefergrau': 'slategrey', 'schokolade': 'choco', 'schwarz': 'black',
    'silber': 'silver', 'sortiert': 'assorti', 'türkis': 'turqouise', 'weiß': 'white', 'kleiner finger': 'pink',
    'assorted': 'assorti', 'chocolate': 'choco', 'cream': 'creme', 'little finger': 'pink', 'turquoise': 'turqouise',
    'dunkelgrün': 'darkgreen'
  };
  Object.keys(ALIAS).forEach(function (k) { if (!KLEUREN[k]) KLEUREN[k] = KLEUREN[ALIAS[k]]; });
  var KLEUR_PARAM = 'filter.v.m.custom.kleur_variant';
  var GETAL_PARAMS = ['filter.v.m.custom.aantal', 'filter.v.m.custom.variant'];
  var taal = (document.documentElement.lang || 'nl').slice(0, 2).toLowerCase();
  var kolom = taal === 'de' ? 1 : taal === 'en' ? 2 : 0;

  function kleurNaam(waarde) {
    var k = String(waarde || '').trim().toLowerCase();
    var r = KLEUREN[k];
    // alleen op .de: ook schrijfwijzen met andere spaties ("Sandy  Brown", "Lightgrey") vinden (#656 punt 11)
    if (!r && kolom === 1) { k = k.replace(/\s+/g, ' '); r = KLEUREN[k] || KLEUREN[k.replace(/ /g, '')]; }
    return r ? r[kolom] : null;
  }
  function getal(waarde) {
    var s = String(waarde || '').trim();
    if (!/^\d+(\.\d+)?$/.test(s)) return null;
    return String(Number(s));
  }
  // Correctie L (10-10-2026): onder Variant (custom.variant) zijn waarden die alleen in hoofdletters/spaties verschillen
  // één waarde ("50 cm", "50cm", "50 Cm" -> "50 cm"). Sleutel: kleine letters zonder spaties; getallen zoals B1.
  var VARIANT_PARAM = 'filter.v.m.custom.variant';
  function sleutel(param, waarde) {
    var g = getal(waarde);
    if (g !== null) return g;
    if (param !== VARIANT_PARAM) return null;
    var s = String(waarde || '').toLowerCase().replace(/\s+/g, '');
    return s || null;
  }
  // Weergave van een Variant-waarde: eenheid los en klein ("50 cm", "25x36 cm"), tekst met een hoofdletter ("Wit").
  function variantNaam(waarde) {
    var s = String(waarde || '').trim().replace(/\s+/g, ' ');
    var m = s.toLowerCase().replace(/\s+/g, '').match(/^([\d.,x+()]+)(mm|cm|m)$/);
    if (m) return m[1] + ' ' + m[2];
    return s.charAt(0).toUpperCase() + s.slice(1);
  }
  function zetLabelTekst(lbl, tekst) {
    for (var i = 0; i < lbl.childNodes.length; i++) {
      var n = lbl.childNodes[i];
      if (n.nodeType === 3 && n.textContent.trim()) { n.textContent = tekst; return; }
    }
  }

  // B1: dubbele getalwaarden samenvoegen in de lijst.
  function voegSamen(root) {
    GETAL_PARAMS.forEach(function (param) {
      var inputs = root.querySelectorAll('input[type="checkbox"][name="' + param + '"]');
      var groepen = {};
      Array.prototype.forEach.call(inputs, function (inp) {
        if (inp.closest('[data-kp-tweeling]')) return;
        var g = sleutel(param, inp.value);
        if (g === null) return;
        if (param === VARIANT_PARAM) {
          var vl = inp.parentElement.querySelector('label');
          if (vl && !vl.dataset.kpVariant) {
            vl.dataset.kpVariant = '1';
            vl.style.textTransform = 'none';
            zetLabelTekst(vl, variantNaam(inp.value));
          }
        }
        var lijst = inp.closest('ul') || root;
        var groepSleutel = g + '|' + (lijst.dataset.kpLijst || (lijst.dataset.kpLijst = String(Math.random()).slice(2)));
        (groepen[groepSleutel] = groepen[groepSleutel] || []).push(inp);
      });
      Object.keys(groepen).forEach(function (k) {
        var groep = groepen[k];
        if (groep.length < 2) return;
        groep.sort(function (a, b) { return a.value.length - b.value.length; });
        var hoofd = groep[0];
        var totaal = 0;
        var actief = false;
        groep.forEach(function (inp) {
          var lbl = inp.parentElement.querySelector('label');
          var m = lbl && lbl.textContent.match(/\((\d+)\)\s*$/);
          if (m) totaal += Number(m[1]);
          if (inp.checked) actief = true;
        });
        hoofd.dataset.kpTweelingen = groep.slice(1).map(function (i) { return i.id; }).join(' ');
        hoofd.dataset.kpGetal = sleutel(param, hoofd.value);
        if (actief && !hoofd.checked) hoofd.checked = true;
        if (hoofd.disabled && totaal > 0) hoofd.disabled = false;
        var lbl = hoofd.parentElement.querySelector('label');
        if (lbl) {
          var cnt = lbl.querySelector('.count');
          if (cnt) cnt.textContent = '(' + totaal + ')';
          lbl.classList.remove('facet-checkbox--disabled');
        }
        groep.slice(1).forEach(function (tw) {
          var li = tw.closest('li');
          if (li) { li.setAttribute('data-kp-tweeling', hoofd.id); li.style.display = 'none'; }
          tw.checked = hoofd.checked;
          tw.disabled = false;
        });
      });
    });
  }

  // Bij aan/uit van de zichtbare waarde: de verborgen tweelingen meenemen, vóór de thema-code het formulier leest.
  function sync(e) {
    var t = e.target;
    if (!t || !t.dataset || !t.dataset.kpTweelingen) return;
    t.dataset.kpTweelingen.split(' ').forEach(function (id) {
      var tw = document.getElementById(id);
      if (tw) tw.checked = t.checked;
    });
  }
  document.addEventListener('input', sync, true);
  document.addEventListener('change', sync, true);

  // B1 + B2 in de chipjes van actieve filters.
  function chipjes(root) {
    var params = new URLSearchParams(location.search);
    root.querySelectorAll('a.js-facet-remove[href]').forEach(function (a) {
      if (a.dataset.kpChip) return;
      var tekst = a.querySelector('.text');
      if (!tekst) return;
      var url;
      try { url = new URL(a.href, location.origin); } catch (err) { return; }
      var weg = null;
      GETAL_PARAMS.concat([KLEUR_PARAM]).forEach(function (p) {
        var nu = params.getAll(p), straks = url.searchParams.getAll(p);
        if (nu.length === straks.length + 1) nu.forEach(function (v) { if (straks.indexOf(v) < 0) weg = { p: p, v: v }; });
      });
      if (!weg) return;
      a.dataset.kpChip = '1';
      if (weg.p === KLEUR_PARAM) {
        var n = kleurNaam(weg.v);
        if (n) tekst.textContent = n;
        return;
      }
      var g = sleutel(weg.p, weg.v);
      if (g === null) return;
      var ook = params.getAll(weg.p).filter(function (v) { return v !== weg.v && sleutel(weg.p, v) === g; });
      tekst.textContent = weg.p === VARIANT_PARAM ? variantNaam(weg.v) : g;
      if (ook.length) {
        // eerste chip van dit getal verwijdert alle schrijfwijzen; de andere chip(s) verbergen
        var al = root.querySelector('a[data-kp-chip-getal="' + weg.p + '|' + g + '"]');
        if (al) { var li = a.closest('li'); if (li) li.style.display = 'none'; return; }
        a.setAttribute('data-kp-chip-getal', weg.p + '|' + g);
        var schoon = new URLSearchParams(url.search);
        var rest = schoon.getAll(weg.p).filter(function (v) { return sleutel(weg.p, v) !== g; });
        schoon.delete(weg.p);
        rest.forEach(function (v) { schoon.append(weg.p, v); });
        url.search = schoon.toString();
        a.href = url.pathname + (url.search ? url.search : '');
      }
    });
  }

  // #656 punt 11, optie B (26-10-2026), alleen op .de: de filterwaarde blijft de Engelse/CSS-naam of de bestaande
  // Duitse vertaling. (1) Het zichtbare label en de schermlezertekst in het hele vakje (.facets__label) krijgen de
  // Duitse naam; (2) het rondje krijgt de kleur van de hele waarde via KLEUREN/ALIAS/CSS_KLEUR (Weiß, Braun, Bräunen,
  // Dunkelgrün, Sandy Brown, Sand, Taupe ...); patronen (Muster, Mix, Natur, Metallic ...) blijven zoals het thema ze
  // tekent. nl en en blijven precies zoals ze waren (r2 na testoordeel 26-10-2026).
  var CSS_KLEUR = {
    'wit': 'white', 'groen': 'green', 'rood': 'red', 'goud': 'gold', 'roze': 'pink', 'zilver': 'silver', 'bruin': 'brown',
    'geel': 'yellow', 'dark green': 'darkgreen', 'olijfgroen': 'olive', 'ivoor': 'ivory', 'burgundy': '#800020',
    'bordeaux': '#800020', 'choco': 'chocolate', 'turqouise': 'turquoise', 'goldenrods': 'goldenrod', 'light grey': 'lightgrey',
    'crème': '#fffdd0', 'creme': '#fffdd0', 'sand': '#c2b280', 'taupe': '#a39382'
  };
  // Het thema kleurt het rondje met het laatste woord van de waarde ("Sandy Brown" -> brown, "Dunkelgrün" -> niets).
  // Op .de kiezen we de kleur uit de hele waarde: kleine letters, spaties gelijk, Duitse alias, dan zonder spaties.
  function vasteSleutel(waarde) {
    var k = String(waarde || '').trim().toLowerCase().replace(/\s+/g, ' ');
    return ALIAS[k] || ALIAS[k.replace(/ /g, '')] || k;
  }
  function geldig(c) { return !!c && !!(window.CSS && CSS.supports && CSS.supports('color', c)); }
  function cssKleur(waarde) {
    var k = vasteSleutel(waarde);
    var kandidaten = [CSS_KLEUR[k], CSS_KLEUR[k.replace(/ /g, '')], k.replace(/ /g, '')];
    for (var i = 0; i < kandidaten.length; i++) if (geldig(kandidaten[i])) return kandidaten[i];
    return null;
  }
  function kleurDe(inp, lbl, n) {
    var vak = inp.closest('.facets__label') || inp.closest('li');
    if (vak) {
      vak.querySelectorAll('.visually-hidden').forEach(function (vh) {
        vh.textContent = vh.textContent.replace(String(inp.value).trim(), n);
      });
      vak.querySelectorAll('.facet-checkbox__text-label').forEach(function (t) { t.textContent = n; });
    }
    var p = lbl.querySelector('.pattern');
    if (p) {
      var c = cssKleur(inp.value);
      if (c) p.style.backgroundColor = c;
    }
  }

  // B2: kleurnamen bij de kleurrondjes (tooltip + schermlezer).
  function kleuren(root) {
    root.querySelectorAll('input[type="checkbox"][name="' + KLEUR_PARAM + '"]').forEach(function (inp) {
      var n = kleurNaam(inp.value);
      if (!n) return;
      var lbl = inp.parentElement.querySelector('label');
      if (!lbl || lbl.dataset.kpKleur) return;
      lbl.dataset.kpKleur = inp.value;
      if (kolom === 1) kleurDe(inp, lbl, n);
      if (lbl.hasAttribute('title')) lbl.setAttribute('title', n);
      var vh = lbl.querySelector('.visually-hidden');
      if (vh) vh.textContent = n;
      var txt = lbl.querySelector('.text');
      if (txt) txt.textContent = n;
      if (!lbl.querySelector('.pattern') && !txt && !vh) {
        var c = lbl.querySelector('.count');
        lbl.textContent = n + ' ';
        if (c) lbl.appendChild(c);
      }
    });
  }

  function alles() {
    voegSamen(document);
    kleuren(document);
    chipjes(document);
  }
  var wacht = null;
  function later() { clearTimeout(wacht); wacht = setTimeout(alles, 60); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', alles); else alles();
  new MutationObserver(function (m) {
    for (var i = 0; i < m.length; i++) if (m[i].addedNodes && m[i].addedNodes.length) { later(); return; }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
